import { Box } from '@mui/material';

import ApplicationSearchInput from '../../Common/ApplicationSearchInput';
import FilterSelect from '../../Common/FilterSelect';
import { CHANGE_DETECTION_FILTER_OPTIONS, QC_STATUS_FILTER_OPTIONS } from '../constants';
import {
  SnapshotComparisonFilters as SnapshotComparisonFilterValues,
  TriStateFilter
} from '../types';

/* eslint-disable no-unused-vars */
type SnapshotComparisonFiltersProps = {
  filters: SnapshotComparisonFilterValues;
  onQcStatusChange: (value: TriStateFilter) => void;
  onChangeDetectionStatusChange: (value: TriStateFilter) => void;
  onApplicationNumberSearch: (value: string) => void;
  onClear: () => void;
};
/* eslint-enable no-unused-vars */

const SnapshotComparisonFilters = ({
  filters,
  onQcStatusChange,
  onChangeDetectionStatusChange,
  onApplicationNumberSearch,
  onClear
}: SnapshotComparisonFiltersProps) => {
  return (
    <Box display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <FilterSelect
        label='Curation Status'
        value={filters.qcStatus}
        options={QC_STATUS_FILTER_OPTIONS}
        onChange={value => onQcStatusChange(value as TriStateFilter)}
      />
      <FilterSelect
        label='Changes To Report'
        value={filters.changeDetectionStatus}
        options={CHANGE_DETECTION_FILTER_OPTIONS}
        onChange={value => onChangeDetectionStatusChange(value as TriStateFilter)}
      />
      <ApplicationSearchInput
        value={filters.applicationNumber}
        onSearch={onApplicationNumberSearch}
        onClear={onClear}
      />
    </Box>
  );
};

export default SnapshotComparisonFilters;
